import { t } from "/global/js/translations.min.js?v=1749035975";
export default class DepartmentOpenHours {
  constructor(id) {
    this.id = id;
    this.module = document.querySelector("#" + this.id);
    this.ajaxHandler = '/content/plugins/departments/ajaxHandlerDepartments.php';
    (async () => {
      this.t = await t;
      this.weekDays = {
        "Monday": this.t.__('Monday'),
        "Tuesday": this.t.__('Tuesday'),
        "Wednesday": this.t.__('Wednesday'),
        "Thursday": this.t.__('Thursday'),
        "Friday": this.t.__('Friday'),
        "Saturday": this.t.__('Saturday'),
        "Sunday": this.t.__('Sunday')
      };
      fetch(this.ajaxHandler + '?handler=getDepartmentOpenHours').then(response => response.json().then(response => {
        if (response.error) {
          pubsub.trigger('error', response);
          return;
        }
        if (!response?.departmentDefaultSettings?.openHours) {
          return;
        }
        this.openHours = response.departmentDefaultSettings.openHours;
        this.openHoursExtra = response.departmentDefaultSettings.openHoursExtra;
        this.render();
      }));
    })();
  }
  render() {
    const html = document.createElement('div');
    html.style.maxWidth = '400px';
    html.classList.add('mx-auto');
    html.innerHTML = `
            <div class="row">
                <div class="">
                    <p class="text-secondary headline5">${this.t.department.depaName}</p>
                </div>
            </div>
        `;
    const today = new Date();
    const firstDayOfYear = new Date(today.getFullYear(), 0, 1);
    const pastDaysOfYear = (today - firstDayOfYear) / 86400000;
    const currentWeekNumber = Math.ceil((pastDaysOfYear + firstDayOfYear.getDay() + 1) / 7);

    //Overriding weekdays if extraOpenHours is set
    if (this.openHoursExtra) {
      for (const openHourExtra of this.openHoursExtra) {
        const extraDate = new Date(openHourExtra.date);
        const weekNumberFromDate = this.getWeekNumber(openHourExtra.date);
        if (currentWeekNumber === weekNumberFromDate) {
          const weekdayName = extraDate.toLocaleDateString('en-US', {
            weekday: 'long'
          });
          this.openHours[weekdayName].start = openHourExtra.start;
          this.openHours[weekdayName].end = openHourExtra.end;
        }
      }
    }
    for (const [day, openHour] of Object.entries(this.openHours)) {
      let openHourStartEnd = this.t.__("Closed");
      if (openHour.start && openHour.end) {
        openHourStartEnd = openHour.start + ' - ' + openHour.end;
      }
      html.innerHTML += `
                <div class="row gx-0 ">
                    <div class="col-5 py-3 border-top headline5">${this.weekDays[day]}</div>
                    <div class="col-7 py-3 border-top headline5">${openHourStartEnd}</div>
                </div>
            `;
    }
    this.module.appendChild(html);
  }
  getWeekNumber(dateString) {
    // https://weeknumber.com/how-to/javascript
    const date = new Date(dateString);
    date.setHours(0, 0, 0, 0);
    // Thursday in current week decides the year.
    date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
    // January 4 is always in week 1.
    const week1 = new Date(date.getFullYear(), 0, 4);
    // Adjust to Thursday in week 1 and count number of weeks from date to week1.
    return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000 - 3 + (week1.getDay() + 6) % 7) / 7);
  }
}